import React from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

const GlobalLoader = () => {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  if (isFetching === 0 && isMutating === 0) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white/70 z-[9999] flex items-center justify-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-indigo-500"></div>
    </div>
  );
};

export default GlobalLoader;